/* eslint-disable no-useless-escape */
export const EXAMPLE_SOURCES = {
  'chat.html': `<!DOCTYPE html>
<html lang="sv">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>AI-chatt</title>
<script src="/applab-sdk.js"><\/script>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: system-ui, sans-serif; background: #0f0f0f; color: #e0e0e0; height: 100vh; display: flex; flex-direction: column; }
  #header { padding: 14px 20px; background: #1a1a1a; border-bottom: 1px solid rgba(255,255,255,0.08); font-weight: 700; font-size: 0.9rem; color: #fff; }
  #header span { color: #00897B; }
  #messages { flex: 1; overflow-y: auto; padding: 20px; display: flex; flex-direction: column; gap: 12px; }
  .msg { max-width: 80%; padding: 10px 14px; border-radius: 12px; line-height: 1.5; font-size: 0.88rem; white-space: pre-wrap; }
  .user { background: #00897B22; border: 1px solid #00897B44; align-self: flex-end; color: #e0e0e0; }
  .assistant { background: #1e1e1e; border: 1px solid rgba(255,255,255,0.08); align-self: flex-start; color: #ccc; }
  .thinking { color: #555; font-style: italic; }
  #footer { padding: 12px 16px; background: #1a1a1a; border-top: 1px solid rgba(255,255,255,0.08); display: flex; gap: 10px; }
  #input { flex: 1; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12); border-radius: 8px; padding: 10px 14px; color: white; font-size: 0.88rem; outline: none; resize: none; font-family: inherit; }
  #input:focus { border-color: #00897B; }
  #send { background: #00897B; color: white; border: none; border-radius: 8px; padding: 0 18px; font-weight: 700; cursor: pointer; font-size: 0.85rem; }
  #send:disabled { opacity: 0.4; cursor: not-allowed; }
  #external-notice { display: none; flex: 1; align-items: center; justify-content: center; flex-direction: column; gap: 12px; padding: 40px 24px; text-align: center; }
  #external-notice h2 { font-size: 1rem; color: #ccc; font-weight: 700; }
  #external-notice p { font-size: 0.85rem; color: #666; max-width: 320px; line-height: 1.6; }
<\/style>
<\/head>
<body>
<div id="header">App<span>LAB<\/span> · AI-chatt<\/div>
<div id="messages">
  <div class="msg assistant">Hej! Jag är en AI-assistent. Vad kan jag hjälpa dig med?<\/div>
<\/div>
<div id="footer">
  <textarea id="input" rows="1" placeholder="Skriv ett meddelande…"><\/textarea>
  <button id="send">Skicka<\/button>
<\/div>
<div id="external-notice">
  <h2>AI-chatt<\/h2>
  <p>Den här appen använder AI och är tillgänglig internt. Kontakta avsändaren för en live-demo.<\/p>
<\/div>
<script>
const messages = document.getElementById('messages');
const input = document.getElementById('input');
const send = document.getElementById('send');
const history = [];

if (AppLabSDK.isExternalView) {
  document.getElementById('messages').style.display = 'none';
  document.getElementById('footer').style.display = 'none';
  document.getElementById('external-notice').style.display = 'flex';
}

function addMsg(role, text) {
  const div = document.createElement('div');
  div.className = 'msg ' + role;
  div.textContent = text;
  messages.appendChild(div);
  messages.scrollTop = messages.scrollHeight;
  return div;
}

async function submit() {
  const text = input.value.trim();
  if (!text) return;
  input.value = '';
  send.disabled = true;
  addMsg('user', text);
  history.push({ role: 'user', content: text });
  const thinking = addMsg('assistant thinking', 'Tänker…');
  try {
    const res = await AppLabSDK.run('ai.chat', {
      messages: history,
      model: 'claude-haiku-4-5',
      max_tokens: 512,
      system: 'Du är en hjälpsam assistent. Svara alltid på svenska om inte användaren skriver på ett annat språk.',
    });
    const reply = res.content || '';
    thinking.className = 'msg assistant';
    thinking.textContent = reply;
    history.push({ role: 'assistant', content: reply });
  } catch (e) {
    thinking.className = 'msg assistant';
    thinking.textContent = '⚠️ Fel: ' + e.message;
  } finally {
    send.disabled = false;
    input.focus();
  }
}

send.addEventListener('click', submit);
input.addEventListener('keydown', e => {
  if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); }
});
<\/script>
<\/body>
<\/html>`,

  'summarizer.html': `<!DOCTYPE html>
<html lang="sv">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Textsammanfattare</title>
<script src="/applab-sdk.js"><\/script>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: system-ui, sans-serif; background: #0f0f0f; color: #e0e0e0; min-height: 100vh; padding: 24px; }
  h1 { font-size: 1.1rem; font-weight: 800; margin-bottom: 4px; }
  h1 span { color: #00897B; }
  p.sub { color: #666; font-size: 0.82rem; margin-bottom: 20px; }
  label { font-size: 0.8rem; color: #888; display: block; margin-bottom: 6px; }
  textarea { width: 100%; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.12); border-radius: 8px; padding: 12px; color: white; font-size: 0.85rem; font-family: inherit; outline: none; resize: vertical; }
  textarea:focus { border-color: #00897B; }
  .row { display: flex; gap: 10px; align-items: center; margin: 12px 0; flex-wrap: wrap; }
  select { background: #1e1e1e; border: 1px solid rgba(255,255,255,0.12); border-radius: 6px; padding: 7px 12px; color: white; font-size: 0.82rem; outline: none; }
  button { background: #00897B; color: white; border: none; border-radius: 8px; padding: 9px 22px; font-weight: 700; cursor: pointer; font-size: 0.85rem; }
  button:disabled { opacity: 0.4; cursor: not-allowed; }
  #result { margin-top: 20px; background: #1a1a1a; border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 16px; font-size: 0.88rem; line-height: 1.6; color: #ccc; white-space: pre-wrap; display: none; }
  #result.visible { display: block; }
  .chip { display: inline-flex; align-items: center; gap: 5px; background: rgba(0,137,123,0.15); border: 1px solid rgba(0,137,123,0.3); border-radius: 6px; padding: 3px 10px; font-size: 0.72rem; color: #00897B; margin-top: 10px; }
  #external-notice { display: none; background: rgba(0,137,123,0.08); border: 1px solid rgba(0,137,123,0.2); border-radius: 10px; padding: 24px; text-align: center; margin-top: 20px; }
  #external-notice h2 { font-size: 1rem; color: #ccc; font-weight: 700; margin-bottom: 8px; }
  #external-notice p { font-size: 0.85rem; color: #666; line-height: 1.6; }
<\/style>
<\/head>
<body>
<h1>App<span>LAB<\/span> · Textsammanfattare<\/h1>
<p class="sub">Klistra in valfri text och få en kompakt sammanfattning.<\/p>
<div id="ai-section">
  <label>Text att sammanfatta<\/label>
  <textarea id="text" rows="8" placeholder="Klistra in text här…"><\/textarea>
  <div class="row">
    <label style="margin:0">Längd:<\/label>
    <select id="length">
      <option value="kort">Kort (2–3 meningar)<\/option>
      <option value="medium" selected>Medium (5–7 meningar)<\/option>
      <option value="detaljerad">Detaljerad (10+ meningar)<\/option>
    <\/select>
    <button id="btn">Sammanfatta<\/button>
  <\/div>
  <div id="result"><\/div>
<\/div>
<div id="external-notice">
  <h2>Textsammanfattare<\/h2>
  <p>Den här appen använder AI för att sammanfatta text och är tillgänglig internt på Tikab.<br>Kontakta avsändaren för en live-demo.<\/p>
<\/div>
<script>
if (AppLabSDK.isExternalView) {
  document.getElementById('ai-section').style.display = 'none';
  document.getElementById('external-notice').style.display = 'block';
}
const btn = document.getElementById('btn');
const result = document.getElementById('result');
if (btn) {
  btn.addEventListener('click', async () => {
    const text = document.getElementById('text').value.trim();
    if (!text) return;
    const length = document.getElementById('length').value;
    btn.disabled = true;
    result.className = 'visible';
    result.textContent = 'Sammanfattar…';
    try {
      const res = await AppLabSDK.run('ai.chat', {
        messages: [{ role: 'user', content: text }],
        model: 'claude-haiku-4-5',
        max_tokens: 800,
        system: 'Du sammanfattar text på svenska. Ge en ' + length + ' sammanfattning av den text användaren skickar. Inga inledningar, bara sammanfattningen direkt.',
      });
      const reply = res.content || '';
      const tokens = (res.usage ? res.usage.tokens_in : 0) + (res.usage ? res.usage.tokens_out : 0);
      result.innerHTML = reply + (tokens ? '<div class="chip">🔢 ' + tokens + ' tokens<\/div>' : '');
    } catch (e) {
      result.textContent = '⚠️ Fel: ' + e.message;
    } finally {
      btn.disabled = false;
    }
  });
}
<\/script>
<\/body>
<\/html>`,

  'model-comparison.html': `<!DOCTYPE html>
<html lang="sv">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Modell-jämförelse</title>
<script src="/applab-sdk.js"><\/script>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: system-ui, sans-serif; background: #0f0f0f; color: #e0e0e0; min-height: 100vh; padding: 24px; }
  h1 { font-size: 1.1rem; font-weight: 800; margin-bottom: 4px; }
  h1 span { color: #00897B; }
  .sub { color: #666; font-size: 0.82rem; margin-bottom: 20px; }
  label { font-size: 0.8rem; color: #888; display: block; margin-bottom: 6px; }
  textarea { width: 100%; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.12); border-radius: 8px; padding: 12px; color: white; font-size: 0.85rem; font-family: inherit; outline: none; resize: vertical; }
  textarea:focus { border-color: #00897B; }
  .actions { display: flex; align-items: center; gap: 12px; margin: 12px 0 20px; flex-wrap: wrap; }
  button { background: #00897B; color: white; border: none; border-radius: 8px; padding: 9px 22px; font-weight: 700; cursor: pointer; font-size: 0.85rem; }
  button:disabled { opacity: 0.4; cursor: not-allowed; }
  .warning { background: rgba(255,160,0,0.12); border: 1px solid rgba(255,160,0,0.3); border-radius: 8px; padding: 8px 12px; font-size: 0.78rem; color: #ffa000; }
  .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 16px; }
  .col { background: #1a1a1a; border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 16px; display: flex; flex-direction: column; gap: 10px; }
  .col-header { display: flex; align-items: center; justify-content: space-between; }
  .col-title { font-weight: 800; font-size: 0.9rem; color: white; }
  .badge { font-size: 0.65rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; background: rgba(0,137,123,0.18); color: #00897B; border: 1px solid rgba(0,137,123,0.3); }
  .badge.neutral { background: rgba(255,255,255,0.06); color: #777; border-color: rgba(255,255,255,0.1); }
  .badge.warn { background: rgba(255,152,0,0.15); color: #ff9800; border-color: rgba(255,152,0,0.3); }
  .response { flex: 1; font-size: 0.82rem; line-height: 1.6; color: #ccc; white-space: pre-wrap; min-height: 80px; }
  .response.placeholder { color: #444; font-style: italic; }
  .response.loading { color: #555; }
  .response.error { color: #ef9a9a; }
  .meta { display: flex; gap: 8px; flex-wrap: wrap; }
  .chip { font-size: 0.68rem; padding: 2px 8px; border-radius: 20px; background: rgba(255,255,255,0.05); color: #666; border: 1px solid rgba(255,255,255,0.08); }
  .chip.green { background: rgba(0,137,123,0.12); color: #00897B; border-color: rgba(0,137,123,0.2); }
  #quota-warning { display: none; margin-top: 16px; padding: 10px 14px; background: rgba(255,152,0,0.12); border: 1px solid rgba(255,152,0,0.3); border-radius: 8px; font-size: 0.8rem; color: #ff9800; }
<\/style>
<\/head>
<body>
<h1>App<span>LAB<\/span> · Modell-jämförelse<\/h1>
<p class="sub">Kör samma prompt mot Haiku, Sonnet och Opus – jämför svar, kostnad och hastighet.<\/p>
<label>Din prompt<\/label>
<textarea id="prompt" rows="4" placeholder="Skriv en prompt här, t.ex. 'Förklara betonghållfasthet på ett enkelt sätt'"><\/textarea>
<div class="actions">
  <button id="btn">Kör på alla modeller<\/button>
  <span class="warning">⚠️ Kör 3 anrop mot AI – använder din kvot<\/span>
<\/div>
<div class="grid">
  <div class="col" id="col-haiku">
    <div class="col-header"><span class="col-title">Haiku 4.5<\/span><span class="badge neutral">Snabb & billig<\/span><\/div>
    <div class="response placeholder" id="resp-haiku">Väntar på prompt…<\/div>
    <div class="meta" id="meta-haiku"><\/div>
  <\/div>
  <div class="col" id="col-sonnet">
    <div class="col-header"><span class="col-title">Sonnet 4.6<\/span><span class="badge">Rekommenderad<\/span><\/div>
    <div class="response placeholder" id="resp-sonnet">Väntar på prompt…<\/div>
    <div class="meta" id="meta-sonnet"><\/div>
  <\/div>
  <div class="col" id="col-opus">
    <div class="col-header"><span class="col-title">Opus 4.7<\/span><span class="badge warn">Kraftfullast · dyrast<\/span><\/div>
    <div class="response placeholder" id="resp-opus">Väntar på prompt…<\/div>
    <div class="meta" id="meta-opus"><\/div>
  <\/div>
<\/div>
<div id="quota-warning">⚠️ Kvoten börjar ta slut – du har förbrukat <span id="quota-pct">?<\/span>% av din månadskvot.<\/div>
<script>
var MODELS = [
  { id: 'claude-haiku-4-5',  key: 'haiku',  label: 'Haiku 4.5'  },
  { id: 'claude-sonnet-4-6', key: 'sonnet', label: 'Sonnet 4.6' },
  { id: 'claude-opus-4-7',   key: 'opus',   label: 'Opus 4.7'   },
];
var btn = document.getElementById('btn');
AppLabSDK.on('quota_warning', function(data) {
  var el = document.getElementById('quota-warning');
  document.getElementById('quota-pct').textContent = data.percent_used;
  el.style.display = 'block';
});
btn.addEventListener('click', function() {
  var prompt = document.getElementById('prompt').value.trim();
  if (!prompt) return;
  btn.disabled = true;
  MODELS.forEach(function(m) {
    var resp = document.getElementById('resp-' + m.key);
    resp.className = 'response loading';
    resp.textContent = 'Anropar ' + m.label + '…';
    document.getElementById('meta-' + m.key).innerHTML = '';
  });
  MODELS.forEach(function(m) {
    var t0 = Date.now();
    AppLabSDK.run('ai.chat', {
      messages:   [{ role: 'user', content: prompt }],
      model:      m.id,
      max_tokens: 600,
      system:     'Svara på svenska om inte prompten anger annat. Håll svaret koncist.',
    }).then(function(res) {
      var ms = Date.now() - t0;
      var tokIn  = res.usage ? res.usage.tokens_in  : 0;
      var tokOut = res.usage ? res.usage.tokens_out : 0;
      var cost   = res.usage ? res.usage.cost_usd   : 0;
      var resp = document.getElementById('resp-' + m.key);
      resp.className = 'response';
      resp.textContent = res.content || '';
      var meta = document.getElementById('meta-' + m.key);
      meta.innerHTML =
        '<span class="chip">' + (tokIn + tokOut) + ' tokens<\/span>' +
        '<span class="chip green">$' + (cost || 0).toFixed(5) + '<\/span>' +
        '<span class="chip">' + ms + ' ms<\/span>';
    }).catch(function(err) {
      var resp = document.getElementById('resp-' + m.key);
      resp.className = 'response error';
      resp.textContent = '⚠️ ' + (err.message || 'Fel');
    }).finally(function() {
      var stillLoading = MODELS.some(function(x) {
        return document.getElementById('resp-' + x.key).classList.contains('loading');
      });
      if (!stillLoading) btn.disabled = false;
    });
  });
});
<\/script>
<\/body>
<\/html>`,

  'qr-generator.html': `<!DOCTYPE html>
<html lang="sv">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>QR-generator</title>
<script src="/applab-sdk.js"><\/script>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: system-ui, sans-serif; background: #0f0f0f; color: #e0e0e0; min-height: 100vh; padding: 24px; }
  h1 { font-size: 1.1rem; font-weight: 800; margin-bottom: 4px; }
  h1 span { color: #00897B; }
  p.sub { color: #666; font-size: 0.82rem; margin-bottom: 20px; }
  label { font-size: 0.8rem; color: #888; display: block; margin-bottom: 6px; }
  input, select, textarea { width: 100%; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.12); border-radius: 8px; padding: 10px 12px; color: white; font-size: 0.88rem; font-family: inherit; outline: none; }
  input:focus, select:focus, textarea:focus { border-color: #00897B; }
  select { background: #1e1e1e; cursor: pointer; }
  .row { display: flex; gap: 12px; margin: 14px 0; flex-wrap: wrap; align-items: flex-end; }
  .field { flex: 1; min-width: 140px; }
  button { background: #00897B; color: white; border: none; border-radius: 8px; padding: 10px 24px; font-weight: 700; cursor: pointer; font-size: 0.88rem; white-space: nowrap; }
  button:disabled { opacity: 0.4; cursor: not-allowed; }
  #result { margin-top: 24px; display: none; text-align: center; }
  #result.visible { display: block; }
  #qr-img { max-width: 300px; border-radius: 12px; display: block; margin: 0 auto 16px; }
  .actions { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; margin-top: 8px; }
  .btn-outline { background: transparent; border: 1px solid rgba(255,255,255,0.15); color: #ccc; }
  #status { font-size: 0.82rem; color: #888; margin-top: 8px; min-height: 20px; text-align: center; }
  #error { color: #ef5350; font-size: 0.82rem; margin-top: 12px; display: none; }
<\/style>
<\/head>
<body>
<h1>App<span>LAB<\/span> · QR-generator<\/h1>
<p class="sub">Skapa en QR-kod för vilken text eller URL som helst.<\/p>
<label>Text eller URL att koda<\/label>
<textarea id="text" rows="3" placeholder="https://lagbasn.se eller valfri text…"><\/textarea>
<div class="row">
  <div class="field"><label>Storlek<\/label><select id="size"><option value="200">200 × 200 px<\/option><option value="300" selected>300 × 300 px<\/option><option value="500">500 × 500 px<\/option><\/select><\/div>
  <div class="field"><label>Felkorrigering<\/label><select id="ecl"><option value="L">L — Låg<\/option><option value="M" selected>M — Medium<\/option><option value="Q">Q — Kvartil<\/option><option value="H">H — Hög<\/option><\/select><\/div>
  <button id="btn">Generera QR<\/button>
<\/div>
<div id="error"><\/div>
<div id="result">
  <img id="qr-img" alt="QR-kod" \/>
  <div id="status"><\/div>
  <div class="actions">
    <button class="btn-outline" id="download-btn">Ladda ner PNG<\/button>
    <button class="btn-outline" id="copy-btn">Kopiera bild<\/button>
  <\/div>
<\/div>
<script>
const btn=document.getElementById('btn'),result=document.getElementById('result'),qrImg=document.getElementById('qr-img'),status=document.getElementById('status'),errorDiv=document.getElementById('error'),downloadBtn=document.getElementById('download-btn'),copyBtn=document.getElementById('copy-btn');
btn.addEventListener('click',async()=>{
  const text=document.getElementById('text').value.trim();if(!text)return;
  btn.disabled=true;errorDiv.style.display='none';result.className='';status.textContent='Genererar QR-kod…';
  try{
    const res=await AppLabSDK.run('qr.generate',{text,size:Number(document.getElementById('size').value),error_correction:document.getElementById('ecl').value});
    qrImg.src=res.data_url;result.className='visible';status.textContent=res.width+'×'+res.height+' px';
  }catch(e){errorDiv.textContent='⚠️ '+e.message;errorDiv.style.display='block';}
  finally{btn.disabled=false;}
});
downloadBtn.addEventListener('click',()=>{if(!qrImg.src)return;const a=document.createElement('a');a.href=qrImg.src;a.download='qr-kod.png';a.click();});
copyBtn.addEventListener('click',async()=>{if(!qrImg.src)return;try{const r=await fetch(qrImg.src),b=await r.blob();await navigator.clipboard.write([new ClipboardItem({'image\/png':b})]);copyBtn.textContent='Kopierat!';setTimeout(()=>copyBtn.textContent='Kopiera bild',2000);}catch{copyBtn.textContent='Misslyckades';setTimeout(()=>copyBtn.textContent='Kopiera bild',2000);}});
<\/script>
<\/body>
<\/html>`,

  'document-analyzer.html': `<!DOCTYPE html>
<html lang="sv">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Dokumentanalys<\/title>
<script src="/applab-sdk.js"><\/script>
<style>
  *{box-sizing:border-box;margin:0;padding:0}body{font-family:system-ui,sans-serif;background:#0f0f0f;color:#e0e0e0;min-height:100vh;padding:24px}h1{font-size:1.1rem;font-weight:800;margin-bottom:4px}h1 span{color:#00897B}p.sub{color:#666;font-size:.82rem;margin-bottom:20px}label{font-size:.8rem;color:#888;display:block;margin-bottom:6px}textarea,input{width:100%;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.12);border-radius:8px;padding:10px 12px;color:white;font-size:.85rem;font-family:inherit;outline:none}textarea:focus,input:focus{border-color:#00897B}.schema-row{display:flex;gap:8px;align-items:center;margin-bottom:8px}.schema-key{flex:1}.schema-desc{flex:2}button{background:#00897B;color:white;border:none;border-radius:8px;padding:9px 22px;font-weight:700;cursor:pointer;font-size:.85rem}.btn-sm{background:rgba(255,255,255,.06);color:#aaa;padding:6px 12px;font-size:.78rem;border-radius:6px;border:1px solid rgba(255,255,255,.1)}.btn-remove{background:transparent;color:#555;border:none;font-size:18px;cursor:pointer;padding:0 4px;line-height:1}.btn-remove:hover{color:#ef5350}.actions{display:flex;gap:10px;align-items:center;margin-top:16px}#result{margin-top:24px;display:none}#result.visible{display:block}.result-grid{display:grid;grid-template-columns:auto 1fr;gap:1px;background:rgba(255,255,255,.06);border-radius:10px;overflow:hidden}.result-key{background:#1a1a1a;padding:10px 14px;font-size:.8rem;color:#888;font-weight:600}.result-val{background:#141414;padding:10px 14px;font-size:.85rem;color:#e0e0e0;word-break:break-word}.chip{display:inline-flex;align-items:center;background:rgba(0,137,123,.12);border:1px solid rgba(0,137,123,.25);border-radius:6px;padding:3px 10px;font-size:.72rem;color:#00897B;margin-top:12px}#error{color:#ef5350;font-size:.82rem;margin-top:12px;display:none}.section{margin-bottom:20px}.section-title{font-size:.75rem;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.8px;margin-bottom:10px}
<\/style>
<\/head>
<body>
<h1>App<span>LAB<\/span> · Dokumentanalys<\/h1>
<p class="sub">Klistra in text och definiera vad som ska extraheras — få ett strukturerat JSON-svar.<\/p>
<div class="section"><label>Text att analysera<\/label><textarea id="text" rows="7" placeholder="Klistra in ett dokument, ett mejl, ett offertbrev, ett protokoll…"><\/textarea><\/div>
<div class="section"><div class="section-title">Fält att extrahera<\/div><div id="fields"><\/div><button class="btn-sm" id="add-field" style="margin-top:4px">+ Lägg till fält<\/button><\/div>
<div class="actions"><button id="btn">Analysera<\/button><span id="status" style="font-size:.8rem;color:#555"><\/span><\/div>
<div id="error"><\/div>
<div id="result"><div class="result-grid" id="result-grid"><\/div><div class="chip" id="usage-chip" style="display:none"><\/div><\/div>
<script>
const fieldsEl=document.getElementById('fields'),btn=document.getElementById('btn'),statusEl=document.getElementById('status'),errorDiv=document.getElementById('error'),resultEl=document.getElementById('result'),resultGrid=document.getElementById('result-grid'),usageChip=document.getElementById('usage-chip');
const DEFAULT=[{key:'avsandare',desc:'Avsändarens namn eller företag'},{key:'datum',desc:'Datum (YYYY-MM-DD om möjligt)'},{key:'belopp',desc:'Eventuellt belopp eller kostnad'},{key:'syfte',desc:'Dokumentets huvudsyfte (1 mening)'},{key:'atgard_kravs',desc:'Kräver dokumentet åtgärd? (ja\/nej)'}];
function addRow(k,d){const r=document.createElement('div');r.className='schema-row';r.innerHTML='<input class="schema-key" placeholder="fältnamn" value="'+esc(k)+'" \/><input class="schema-desc" placeholder="beskrivning" value="'+esc(d)+'" \/><button class="btn-remove">×<\/button>';fieldsEl.appendChild(r);}
function esc(s){return String(s||'').replace(/"/g,'&quot;').replace(/</g,'&lt;');}
function getFields(){return Array.from(fieldsEl.querySelectorAll('.schema-row')).map(r=>({key:r.querySelector('.schema-key').value.trim(),desc:r.querySelector('.schema-desc').value.trim()})).filter(f=>f.key);}
DEFAULT.forEach(f=>addRow(f.key,f.desc));
document.getElementById('add-field').addEventListener('click',()=>{addRow('','');fieldsEl.lastChild.querySelector('.schema-key').focus();});
fieldsEl.addEventListener('click',e=>{if(e.target.classList.contains('btn-remove'))e.target.closest('.schema-row').remove();});
btn.addEventListener('click',async()=>{
  const text=document.getElementById('text').value.trim(),fields=getFields();
  if(!text||!fields.length)return;
  const schema={};fields.forEach(f=>schema[f.key]=f.desc);
  btn.disabled=true;statusEl.textContent='Analyserar…';errorDiv.style.display='none';resultEl.className='';
  try{
    const res=await AppLabSDK.run('ai.extract',{text,schema,model:'claude-haiku-4-5'});
    resultGrid.innerHTML='';
    fields.forEach(f=>{const v=res.result?.[f.key];const kEl=document.createElement('div');kEl.className='result-key';kEl.textContent=f.key;const vEl=document.createElement('div');vEl.className='result-val';vEl.textContent=v!=null?String(v):'—';resultGrid.appendChild(kEl);resultGrid.appendChild(vEl);});
    resultEl.className='visible';statusEl.textContent='';
    if(res.usage){const t=(res.usage.tokens_in||0)+(res.usage.tokens_out||0);usageChip.textContent='🔢 '+t+' tokens · $'+(res.usage.cost_usd||0).toFixed(5);usageChip.style.display='inline-flex';}
  }catch(e){errorDiv.textContent='⚠️ '+e.message;errorDiv.style.display='block';statusEl.textContent='';}
  finally{btn.disabled=false;}
});
<\/script>
<\/body>
<\/html>`,

  'feedback-analysis.html': `<!DOCTYPE html>
<html lang="sv">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Feedbackanalys<\/title>
<script src="/applab-sdk.js"><\/script>
<style>
  *{box-sizing:border-box;margin:0;padding:0}body{font-family:system-ui,sans-serif;background:#0f0f0f;color:#e0e0e0;min-height:100vh;padding:24px}h1{font-size:1.1rem;font-weight:800;margin-bottom:4px}h1 span{color:#00897B}p.sub{color:#666;font-size:.82rem;margin-bottom:20px}label{font-size:.8rem;color:#888;display:block;margin-bottom:6px}textarea{width:100%;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.12);border-radius:8px;padding:12px;color:white;font-size:.85rem;font-family:inherit;outline:none;resize:vertical}textarea:focus{border-color:#00897B}button{background:#00897B;color:white;border:none;border-radius:8px;padding:9px 22px;font-weight:700;cursor:pointer;font-size:.88rem;margin-top:14px}button:disabled{opacity:.4;cursor:not-allowed}#results{margin-top:28px;display:none}#results.visible{display:block}.section-title{font-size:.75rem;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.8px;margin-bottom:14px;margin-top:28px}#chart-container{background:#1a1a1a;border-radius:10px;overflow:hidden;margin-bottom:24px}.wordcloud{display:flex;flex-wrap:wrap;gap:8px;padding:20px;background:#1a1a1a;border-radius:10px}.word-chip{display:inline-block;border-radius:6px;padding:4px 12px;background:rgba(0,137,123,.12);border:1px solid rgba(0,137,123,.2);color:#00897B;cursor:default}#error{color:#ef5350;font-size:.82rem;margin-top:14px;display:none}#status{font-size:.82rem;color:#666;margin-top:10px;min-height:20px}
<\/style>
<\/head>
<body>
<h1>App<span>LAB<\/span> · Feedbackanalys<\/h1>
<p class="sub">Klistra in feedback, kommentarer eller fritext — se de vanligaste orden som ordmoln och stapeldiagram.<\/p>
<label>Feedback-text<\/label>
<textarea id="text" rows="8" placeholder="T.ex. mötes-feedback, kundkommentarer, svarsformulär…"><\/textarea>
<button id="btn">Analysera<\/button>
<div id="status"><\/div>
<div id="error"><\/div>
<div id="results">
  <div class="section-title">Topp 10 vanligaste orden<\/div>
  <div id="chart-container"><\/div>
  <div class="section-title">Ordmoln — topp 40 ord<\/div>
  <div class="wordcloud" id="wordcloud"><\/div>
<\/div>
<script>
const btn=document.getElementById('btn'),statusEl=document.getElementById('status'),errorDiv=document.getElementById('error'),resultsEl=document.getElementById('results'),chartCont=document.getElementById('chart-container'),wordcloudEl=document.getElementById('wordcloud');
btn.addEventListener('click',async()=>{
  const text=document.getElementById('text').value.trim();if(!text)return;
  btn.disabled=true;statusEl.textContent='Analyserar ordfrekvens…';errorDiv.style.display='none';resultsEl.className='';chartCont.innerHTML='';wordcloudEl.innerHTML='';
  try{
    const wcRes=await AppLabSDK.run('wordcloud.generate',{text,max_words:40,min_length:3});
    if(!wcRes.words||!wcRes.words.length)throw new Error('Inga ord hittades i texten.');
    statusEl.textContent='Renderar diagram…';
    const top10=wcRes.words.slice(0,10);
    const chartRes=await AppLabSDK.run('chart.render',{type:'bar',labels:top10.map(w=>w.text),datasets:[{label:'Förekomster',data:top10.map(w=>w.value),color:'#00897B'}],title:'Topp 10 vanligaste orden',width:Math.min(window.innerWidth-48,700),height:280});
    chartCont.innerHTML=chartRes.svg;
    const maxV=wcRes.words[0]?.value||1;
    wcRes.words.forEach(w=>{const pct=w.value\/maxV,el=document.createElement('span');el.className='word-chip';el.style.fontSize=(0.72+pct*0.8)+'rem';el.style.opacity=0.5+pct*0.5;el.style.fontWeight=pct>0.6?'700':'400';el.title=w.text+': '+w.value+' gånger';el.textContent=w.text;wordcloudEl.appendChild(el);});
    resultsEl.className='visible';statusEl.textContent=wcRes.total_unique+' unika ord · '+wcRes.words.length+' visas';
  }catch(e){errorDiv.textContent='⚠️ '+e.message;errorDiv.style.display='block';statusEl.textContent='';}
  finally{btn.disabled=false;}
});
<\/script>
<\/body>
<\/html>`,
};
